/**
 * Applications (candidate listing) domain storage. Search state, result
 * batches/paging, selection and the selected-position filter are per-tab
 * (sessionStorage); the list/kanban view type is a cross-tab preference (localStorage).
 */
import Storage from '../index';
import StorageKeys from '../keys';

const applications = {
    getViewType: () => Storage.getRaw(StorageKeys.applicationsViewType),
    setViewType: (view) => Storage.setRaw(StorageKeys.applicationsViewType, view),

    getSearchState: (lang) => Storage.get(StorageKeys.applicationsSearchState(lang), null),
    setSearchState: (lang, state) => Storage.set(StorageKeys.applicationsSearchState(lang), state),

    getResultBatch: () => Storage.get(StorageKeys.applicationsBatch, null),
    setResultBatch: (hashes) => Storage.set(StorageKeys.applicationsBatch, hashes),

    getResultPaging: () => Storage.get(StorageKeys.applicationsPaging, null),
    setResultPaging: (paging) => Storage.set(StorageKeys.applicationsPaging, paging),

    getSelection: () => Storage.get(StorageKeys.applicationsSelection, null),
    setSelection: (hashes) => Storage.set(StorageKeys.applicationsSelection, hashes),

    getSelectedPositions: () => Storage.get(StorageKeys.selectedPositions, null),
    setSelectedPositions: (values) => Storage.set(StorageKeys.selectedPositions, values),
};

export default applications;
